// extracted by mini-css-extract-plugin
export default {"contentIcons":"SocialsIcons_contentIcons__3xZgq","icon":"SocialsIcons_icon__aZNmk"};